<div class="services-payment-dialog">
    <h2>Pago de servicios de la cuota {{ data.installment.numero }}</h2>
    <span class="description">Estos son los servicios asociados a su garantía.</span>
    <div class="service" *ngFor="let service of data.warranty.cotizacion.servicios">
        <span class="service-name">
            {{ service.nombre }}
        </span>
        <div class="service-status">
            <div class="service-status-image" [ngClass]="getStatus(service).toLowerCase()"></div>
            <span class="service-status-text">
                {{ getStatus(service).toUpperCase() }}
            </span>
        </div>
        <button mat-icon-button matTooltip="Descargar comprobante de pago subido por el inquilino" class="download-button" [disabled]="getStatus(service) !== 'PAGADO'" (click)="downloadDocument(service)">
            <mat-icon>download</mat-icon>
        </button>
    </div>
    <div class="no-services" *ngIf="!data.warranty.cotizacion.servicios?.length">
        No hay servicios registrados
    </div>
    <div class="buttons">
        <button mat-raised-button class="garantor-button mini" color="primary" (click)="cerrarDialogo()"> Cerrar </button>
    </div>
</div>
